<template>
    <a :aria-label="props.title" :title="props.title" :href="props.href" :rel="props.rel" :name="props.name" @click.prevent="emits('click')" class="PaginationButton" :disabled="props.disabled">
        <slot />
    </a>
</template>
<script lang="ts" setup>
    import { PropType } from 'vue';
    const emits = defineEmits(['click']);
    const props = defineProps({
        title:{
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: 'paginationButton',
        },
        rel: {
            type: String as PropType<HTMLAnchorElement['rel']>,
            default:'nofollow',
        },
        href: {
            type: String,
            default: '#',
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    })
</script>
<style scoped lang="scss">
    .PaginationButton {
        display: flex;
        justify-content: center;
        height: 100%;
        width: 100%;
        align-items: center;
        border-radius: 0.5rem;
        background-color: $White;
        border: 1px solid $Grey-600;
        color: $Grey-900;
        cursor: pointer;
        text-decoration: none;
        &:hover {
            background-color: $Blue-100;
            color: $Blue-700;
            border-color: $Blue-700;
        }
    }
</style>